export function resolveSectionAnchorId(sectionId: string | null | undefined): string {
  return typeof sectionId === 'string' && sectionId.trim().length > 0 ? sectionId.trim() : '';
}

export function resolveSectionJumpHref(sectionId: string | null | undefined): string {
  const anchorId = resolveSectionAnchorId(sectionId);
  return anchorId ? `#${anchorId}` : '#';
}

export function scrollToSectionAnchor(sectionId: string | null | undefined) {
  const anchorId = resolveSectionAnchorId(sectionId);
  if (!anchorId || typeof document === 'undefined') return false;
  const target = document.getElementById(anchorId);
  if (!target) return false;
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}
